import View from 'view/view'
import template from 'component/uploader/template/media_upload_item.tmpl'
import assets from 'service/assets'
import ResponsiveImageView from 'component/responsive_image/responsive_image'

export default View.extend({
    template,

    events: {
        click: '_onItemClick',
    },

    _onItemClick() {
        this.trigger('MediaUploadItem:remove', { fileModel: this.model })
    },

    render() {
        this.$el.html(
            this.template({
                item: this.model.toJSON(),
            })
        )

        if (this.model.get('path')) {
            this.initSubview(ResponsiveImageView, {
                el: this.$('.js-responsiveImage'),
                imageScale: true,
                sources: [
                    {
                        size: 768,
                        images: [
                            assets.getImageUrl(this.model.get('path'), { format: '80_80' }),
                            assets.getImageUrl(this.model.get('path'), { format: '80_80-2x' }),
                            assets.getImageUrl(this.model.get('path'), { format: '80_80-3x' }),
                        ],
                    },
                    {
                        size: 769,
                        // We cannot guarantee the size of each thumbnail since they are inside a blockGrid, but
                        // using 235x235 as a base size for the thumbnails should be enough for most desktop use cases
                        images: [
                            assets.getImageUrl(this.model.get('path'), { format: '235_235' }),
                            assets.getImageUrl(this.model.get('path'), { format: '235_235-2x' }),
                        ],
                    },
                ],
            }).render()
        }

        return this
    },
})
